import { Component } from '@angular/core';
import { MssFieldBaseFieldTypeComponent } from '../mss-field-base.component';
import { MSS_FORMLY_IMPORTS } from '../../formly-standalone-imports';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'lib-ff-custom-checkbox',
  templateUrl: 'custom-checkbox.component.html',
  imports: [...MSS_FORMLY_IMPORTS, FormsModule, ReactiveFormsModule],
})
export class FormlyCustomCheckboxListComponent extends MssFieldBaseFieldTypeComponent {
  errorId?: string;

  onChange(value, checked) {
    this.formControl.patchValue({ ...this.formControl.value, [value]: checked });
    this.formControl.markAsTouched();
  }
  get hasOnlyText() {
    return (this.props.options as any[]).every((x) => x.label && !x.icon);
  }
  isChecked(id) {
    return this.formControl.value[id];
  }
}
